module.exports = __webpack_public_path__ + "img/Z5.2794d8e4.png";